export let JackpotCounter = (() => {

	const increment = 0.03;
	const interval = 1000;
	const element = document.getElementById('jackpotAmount');

	const init = () => {
		if (element) {

			let jackpot_amount = parseFloat(element.dataset.amount);

			setInterval(() => {
				jackpot_amount += increment;
				element.innerHTML = jackpot_amount.toLocaleString('en-US', {minimumFractionDigits: 2})
			}, interval)
		}
	}

	return {
		element, init
	}

})();
